__turbopack_context__.v({
  "checkIcon": "_0NFieq_checkIcon",
  "divider": "_0NFieq_divider",
  "feature": "_0NFieq_feature",
  "featureContent": "_0NFieq_featureContent",
  "featureListContainer": "_0NFieq_featureListContainer",
  "featureTitle": "_0NFieq_featureTitle",
  "head": "_0NFieq_head",
  "imageContainer": "_0NFieq_imageContainer",
  "planTenureTotalPrice": "_0NFieq_planTenureTotalPrice",
  "planWrapper": "_0NFieq_planWrapper",
  "popularTag": "_0NFieq_popularTag",
  "pricingContainer": "_0NFieq_pricingContainer",
  "subhead": "_0NFieq_subhead",
  "textContainer": "_0NFieq_textContainer",
  "topSection": "_0NFieq_topSection",
  "xlDivider": "_0NFieq_xlDivider",
  "yearlyPrice": "_0NFieq_yearlyPrice",
});
